<script setup>
import ConfirmComponent from '@/components/ConfirmComponent.vue';
import ToastComponent from '@/components/ToastComponent.vue';
// import UserComponent from '@/components/UserComponent.vue'; // 더 이상 필요 없음
import LoginPopup from '@/components/LoginPopupComponent.vue';
import { useAuthStore } from '@/store/auth-store';
import { useReservationCartStore } from '@/store/reservationCart-store';
import { useRouterStore } from '@/store/router-store';
import { storeToRefs } from 'pinia';
import { computed, onBeforeUnmount, onMounted, ref, watchEffect } from 'vue';
import { useRouter } from 'vue-router';

const showLoginPopup = ref(false);
const initialEmailForLogin = ref('');
const socialSignupData = ref(null);
const router = useRouter();
// const userComponentRef = ref(null); // 더 이상 필요 없음
const routerStore = useRouterStore();
const toastComponentRef = ref(null);
const authStore = useAuthStore();
const isLoggedIn = computed(() => !!authStore.userId);
// const userName = computed(() => authStore.userName || authStore.userId);
const userName = computed(() => {
    const customerType = authStore.customerType;
    if (customerType === 'INDV') {
        return authStore.userName || authStore.userId || '';
    } else {
        return authStore.corporationName || authStore.userId || '';
    }
});
const cartStore = useReservationCartStore();
const { cartCount } = storeToRefs(cartStore);
const confirmAction = ref(null);
const showConfirmDialog = ref(false);
const dialogHeader = ref('');
const dialogMessage = ref('');
const dialogcomplete = ref('');
let isConfirming = false;

const showUserMenu = ref(false);
const userMenuRef = ref(null);
const hamburgerButtonRef = ref(null);
const showMobileTopMenu = ref(false);

const onListButtonClick = () => {
    showUserMenu.value = !showUserMenu.value;
};

const handleCancel = () => {
    if (isConfirming) return;
    showConfirmDialog.value = false;
};

const handleIntroduce = () => {
    router.push({ name: 'introduce' });
    showUserMenu.value = false;
};

const handleMyinfo = () => {
    if (!isLoggedIn.value) return;

    if (authStore.customerType === 'INDV') {
        router.push({ name: 'mypage' });
    } else {
        router.push({ name: 'mypage-corp' });
    }
    showUserMenu.value = false;
};

const handleSignup = () => {
    router.push({ name: 'signup' });
    showUserMenu.value = false;
};

const handleGoHome = () => {
    router.push('/');
    showUserMenu.value = false;
};

const handleLogin = () => {
    initialEmailForLogin.value = '';
    showLoginPopup.value = true;
};

const handleLoginSuccess = () => {
    showLoginPopup.value = false;
};

const handleLoginFail = (error) => {
    //console.error('Login failed in parent:', error.message);
    // if (toastComponentRef.value) {
    //     toastComponentRef.value.showToast('error', '로그인 실패', error.message);
    // }
};

const handleRequestSignup = () => {
    showLoginPopup.value = false; // Ensure login popup is closed
    socialSignupData.value = null; // Clear social data
    router.push({ name: 'signup' });
    // showSignupModal.value = true; // Open your signup modal/page
};

const handleSocialNeedsSignup = (data) => {
    // console.log('Social login attempted, but user needs to sign up:', data);
    showLoginPopup.value = false;
    socialSignupData.value = data; // Store data to prefill signup
    router.push({ name: 'signup-normal', query: data });

    // showSignupModal.value = true; // Open signup modal
};

const handleLogout = async () => {
    try {
        setDialogInfo('logout');
        showConfirmDialog.value = true;
        showUserMenu.value = false;
        showLoginPopup.value = false;
        // router.push('/login');
    } catch (error) {
        console.error('Logout failed:', error);
    }
};

const topMenuItems = [
    { name: 'reservation', label: '렌터카예약', icon: 'pi pi-car' },
    { name: 'reservation-lookup', label: '예약조회', icon: 'pi pi-list' },
    { name: 'information', label: '이용안내', icon: 'pi pi-info-circle' },
    { name: 'service', label: '고객센터', icon: 'pi pi-question-circle' },
    { name: 'monthly-rental', label: '월/장기대여', icon: 'pi pi-phone' }
];

const bottomMenuItems = computed(() => {
    return isLoggedIn.value
        ? [
              { name: 'mypage', label: '나의정보', icon: 'pi pi-user', action: handleMyinfo },
              { name: 'logout', label: '로그아웃', icon: 'pi pi-sign-out', action: handleLogout }
              //   { name: 'introduce', label: '회사소개', icon: 'pi pi-car', action: handleIntroduce }
          ]
        : [
              { name: 'signup', label: '홈으로', icon: 'pi pi-home', action: handleGoHome },
              { name: 'signup', label: '회원가입', icon: 'pi pi-sign-in', action: handleSignup }
              //   { name: 'introduce', label: '회사소개', icon: 'pi pi-car', action: handleIntroduce }
          ];
});

const setDialogInfo = (action) => {
    confirmAction.value = action;
    dialogHeader.value = dialogInfo[action].header;
    dialogMessage.value = dialogInfo[action].message;
    dialogcomplete.value = dialogInfo[action].completemessage;
};

const dialogInfo = {
    logout: {
        header: '로그아웃',
        message: '로그아웃 하시겠습니까?',
        completemessage: '로그아웃 되었습니다.'
    }
};

const handleConfirm = async () => {
    if (isConfirming) return;
    isConfirming = true;

    try {
        switch (confirmAction.value) {
            case 'logout':
                await authStore.logout();
                // router.push('/');
                break;
            default:
                break;
        }

        if (toastComponentRef.value) {
            toastComponentRef.value.showToast('success', dialogHeader.value, dialogcomplete.value);
        }
    } catch (error) {
        console.error('Confirmation error:', error);
        if (toastComponentRef.value) {
            toastComponentRef.value.showToast('error', dialogHeader.value, '로그아웃 실패하였습니다.');
        }
    } finally {
        setTimeout(() => {
            isConfirming = false;
            showConfirmDialog.value = false;
            showUserMenu.value = false;
            showLoginPopup.value = false;
        }, 500);
    }
};

const onClickOutside = (event) => {
    // userMenuRef.value (팝업 메뉴)가 존재하고,
    // 이벤트 타겟이 userMenuRef.value (팝업 메뉴)의 자식 요소도 아니고,
    // 이벤트 타겟이 hamburgerButtonRef.value (햄버거 버튼)의 자식 요소도 아니라면
    // -> 팝업 메뉴 외부를 클릭한 것
    if (userMenuRef.value && !userMenuRef.value.contains(event.target) && !(hamburgerButtonRef.value && hamburgerButtonRef.value.contains(event.target))) {
        showUserMenu.value = false;
        // showMobileTopMenu.value는 여기서 변경하지 않음. watchEffect가 처리
    }
};

const updateMobileMenuVisibility = () => {
    showMobileTopMenu.value = window.innerWidth <= 768;
};

onMounted(() => {
    authStore.initializeAuth();
    document.addEventListener('click', onClickOutside);
    updateMobileMenuVisibility();
    window.addEventListener('resize', updateMobileMenuVisibility);
});

onBeforeUnmount(() => {
    document.removeEventListener('click', onClickOutside);
    window.removeEventListener('resize', updateMobileMenuVisibility);
});

watchEffect(() => {
    showMobileTopMenu.value = window.innerWidth <= 768;
});
</script>

<template>
    <div class="topbar">
        <div class="left-section">
            <div class="logo-container">
                <a @click="router.push('/')">
                    <img src="/image/gomduri_icon/h_logo.png" alt="Logo" class="logo-image" />
                </a>
            </div>
        </div>

        <div class="hidden w-full md:block md:w-auto">
            <ul class="menu-list">
                <li v-for="item in topMenuItems" :key="item.name">
                    <a @click.stop="router.push({ name: item.name })" class="menu-item">
                        {{ item.label }}
                    </a>
                </li>
            </ul>
        </div>

        <div class="right-section flex items-center">
            <span v-if="isLoggedIn" class="userinfo">
                <span class="mr-3">환영합니다.</span> [<span class="userinfo2 ml-2 mr-2">{{ userName }}</span> ]<span class="ml-2 mr-1">님</span>
                <button v-if="!showMobileTopMenu" @click="handleLogout()" class="logout-button p-0" aria-label="로그아웃">
                    <i class="pi pi-sign-out text-xl text-gray-700 hover:text-gray-900"></i>
                </button>
            </span>
            <span v-else class="userinfo">
                <!-- <button class="user-button" @click="router.push({ name: 'login' })"> -->
                <button class="user-button" @click="handleLogin">
                    <div class="button-content">
                        <!-- <i class="pi pi-user"></i> -->
                        <span>로그인</span>
                    </div>
                </button>
                <LoginPopup v-model="showLoginPopup" @login-success="handleLoginSuccess" @login-fail="handleLoginFail" @request-signup="handleRequestSignup" @social-needs-signup="handleSocialNeedsSignup" />
                <button v-if="!showMobileTopMenu" class="user-button" @click="router.push({ name: 'introduce' })">
                    <div class="button-content">
                        <span>회사소개</span>
                    </div>
                </button>
                <!-- <button class="user-button" @click="router.push({ name: 'signup' })">
                    <div class="button-content">
                        <span>회원가입</span>
                    </div>
                </button> -->
            </span>

            <button @click="router.push({ name: 'reservation-cart' })" class="user-button cart-button p-0" aria-label="장바구니">
                <i class="pi pi-shopping-cart text-xl text-gray-700 hover:text-gray-900"></i>
                <span v-if="cartCount > 0" class="badge bg-red-600 text-white text-xs w-3 h-3 flex items-center justify-center rounded-full">
                    {{ cartCount }}
                </span>
            </button>

            <button class="hamburger-button" @click.stop="onListButtonClick">
                <i class="pi pi-bars"></i>
            </button>

            <div v-if="showUserMenu" ref="userMenuRef" class="user-popup">
                <div class="user-content">
                    <div v-if="showMobileTopMenu" class="top-menu-container">
                        <button
                            v-for="item in topMenuItems"
                            :key="item.name"
                            class="user-button"
                            @click.stop="
                                router.push({ name: item.name });
                                onListButtonClick();
                            "
                        >
                            <div class="button-content">
                                <i :class="item.icon"></i>
                                <span>{{ item.label }}</span>
                            </div>
                        </button>
                    </div>

                    <div class="separator"></div>

                    <div class="bottom-menu-container">
                        <button v-for="item in bottomMenuItems" :key="item.name" class="user-button" @click.stop="item.action ? item.action() : router.push({ name: item.name })">
                            <div class="button-content">
                                <i :class="item.icon"></i>
                                <span>{{ item.label }}</span>
                            </div>
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <ToastComponent ref="toastComponentRef" />
        <ConfirmComponent v-model:visible="showConfirmDialog" :dialogHeader="dialogHeader" :dialogMessage="dialogMessage" dialogIcon="pi pi-exclamation-triangle" dialogButtonSeverity="danger" @confirm="handleConfirm" @cancel="handleCancel" />
    </div>
</template>

<style scoped>
.user-popup {
    position: absolute;
    top: 2.2rem;
    right: 0;
    width: auto;
    background-color: white;
    border: 0.1rem solid #ddd;
    overflow: hidden;
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    z-index: 1001;
    display: flex;
    flex-direction: column;
    padding: 0;
}

.user-content {
    width: 100%;
    display: flex;
    flex-direction: column;
    border-radius: 8px;
    min-width: 8rem;
}

.button-container {
    display: flex;
    flex-direction: column;
    gap: 0.2rem;
    width: 100%;
    height: 100%;
    padding: 0.3rem;
}

.top-menu-container,
.bottom-menu-container {
    display: flex;
    flex-direction: column; /* 세로로 버튼 배치 */
    width: 100%;
}

.separator {
    height: 1px;
    background-color: #ddd;
    margin: 0; /* 상하 마진 제거 */
}

.user-button {
    display: flex;
    align-items: center;
    justify-content: flex-start; /* 왼쪽 정렬 */
    background-color: white;
    border: none;
    padding: 0.5rem 0.7rem; /* 상하좌우 패딩 */
    cursor: pointer;
    font-weight: bold;
    transition:
        color 0.3s ease,
        background-color 0.3s ease;
    /* width: 100%; */
    font-family: 'SCoreDream400';
    font-size: 0.85rem;
    text-align: left;
}

.user-button:hover {
    color: #0038ea;
    font-family: 'SCoreDream500';
}

.logout-button {
    display: flex;
    align-items: center;
    justify-content: flex-start; /* 왼쪽 정렬 */
    background-color: white;
    border: none;
    padding: 0.2rem 0.5rem; /* 상하좌우 패딩 */
    cursor: pointer;
    font-weight: bold;
    transition:
        color 0.3s ease,
        background-color 0.3s ease;
    /* width: 100%; */
    font-family: 'SCoreDream400';
    font-size: 0.85rem;
    text-align: left;
}

.logout-button:hover {
    color: #0038ea;
    font-family: 'SCoreDream500';
}

.button-content {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    margin: 0.1rem;
}

.user-button i {
    margin-right: 0.8rem;
    font-size: 1rem;
}

/* 나머지 TopBar 스타일 (이전과 동일) */
.topbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 1rem;
    height: 4rem;
    border-bottom: 0.1rem solid #ddd;
    background-color: #fff;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 1000;
}

.hamburger-button {
    position: relative; /* Make the button the positioning context */
    background: none;
    border: none;
    cursor: pointer;
    font-size: 1rem;
    /* z-index: 1000;  Remove z-index from here */
}

.left-section,
.menu-section,
.right-section {
    display: flex;
    align-items: center;
}

.left-section {
    flex: 0 0 auto;
}

.menu-section {
    flex: 1 1 auto;
    font-family: 'SCoreDream500';
    justify-content: left;
    font-size: 1rem;
}

.right-section {
    flex: 0 0 auto;
    font-family: 'SCoreDream400';
    font-size: 0.875rem;
    position: relative; /* Add relative positioning */
}

.logo-container {
    margin-left: 6rem;
}

.logo-image {
    height: 2.5rem;
    width: 8.5rem;
    cursor: pointer;
    object-fit: contain;
}

.userinfo {
    font-family: 'SCoreDream400';
    font-size: 0.875rem;
    color: #5f6368;
    display: flex;
    align-items: center;
}

.logout-link {
    margin-left: 0.3rem;
    font-family: 'SCoreDream400';
    font-size: 0.8rem;
    color: #0038ea;
}

.userinfo2 {
    font-size: 0.875rem;
    font-family: 'SCoreDream500';
    color: #0038ea;
}

.action-button {
    display: flex;
    align-items: center;
    margin-left: auto;
}

.menu-section {
    overflow-x: auto;
    white-space: nowrap;
    padding-left: 5rem;
}

.menu-toggle-button {
    display: inline-flex;
    align-items: center;
    color: #5f6368;
    background-color: transparent;
    border: none;
    cursor: pointer;
}

.menu-list {
    display: flex;
    flex-direction: row;
    padding: 0;
    margin: 0;
    list-style-type: none;
}

.menu-item {
    display: block;
    padding: 0.5rem 1rem;
    color: #5f6368;
    cursor: pointer;
    text-decoration: none;
    transition: color 0.3s ease;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-family: 'SCoreDream500';
    font-size: 1rem;
}

.menu-item:hover,
.menu-item.active {
    color: #0038ea;
}
.cart-button {
    position: relative;
}
.cart-button .badge {
    position: absolute;
    top: 0.15rem;
    right: 0.95rem;
}

/* User Menu Panel Styles */
/* .user-menu {
  position: absolute;
  top: 100%;
  right: 0;
  background-color: white;
  border: 1px solid #ddd;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  z-index: 1001;
  width: 150px;
  padding: 0.5rem 0;
} */

/* .user-menu .menu-item {
    padding: 0.75rem 1rem;
    border-bottom: 1px solid #eee;
    font-size: 0.875rem;
} */

/* .user-menu .menu-item:last-child {
  border-bottom: none;
} */

/* .user-menu .menu-item:hover {
      background-color: #f5f5f5;
} */

@media (max-width: 768px) {
    .menu-list {
        flex-direction: column;
        background-color: #fff;
        position: absolute;
        top: 100%;
        left: 0;
        right: 0;
        box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
    }

    .menu-item {
        padding: 1rem;
        border-top: 1px solid #eee;
    }

    .logo-container {
        margin-left: 0;
    }

    .logo-image {
        height: 2.5rem;
        width: 7.5rem;
        cursor: pointer;
        object-fit: contain;
    }

    .hamburger-button {
        right: 0.4rem;
    }

    .user-popup {
        right: 0.3rem;
    }
}
</style>
